import { ErrorTagUtil } from '@onshape/www-inertia';
import errorReporter from '~/utils/AaaSentryIo';

export type DriftSubmissionData = {
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};

const driftBotPlaybookIds = {
  homePageFree: 2819637,
};

const showDriftBotOrThrow = ({
  playbookId,
  submissionData,
  redirectUrl,
}: {
  playbookId: number;
  submissionData: DriftSubmissionData;
  redirectUrl?: string | null;
}): void => {
  if (import.meta.server) {
    console.warn('useDrift cannot be used on the server side, skipping');
    return;
  }

  if (!window.drift || !window.drift.api) {
    errorReporter.postToSentry({
      tag: ErrorTagUtil.personalizationError,
      msg: `no Driftbot present on ${window.location.pathname}`,
    });
    const { mouseFlowPush } = useTracking();

    mouseFlowPush(['setVariable', 'driftbot-error', 'no-driftbot-present', 'session', false]);

    throw new Error('no driftbot present');
  }

  const opts: { campaignId: number; followupUrl?: string } = {
    campaignId: playbookId,
  };
  if (redirectUrl) {
    opts.followupUrl = redirectUrl;
  }

  window.drift.api.collectFormData(submissionData, opts);
};

const openDrift = (): void => {
  if (import.meta.server) {
    console.warn('useDrift cannot be used on the server side, skipping');
    return;
  }

  if (!window.drift || !window.drift.api) {
    errorReporter.postToSentry({
      tag: ErrorTagUtil.personalizationError,
      msg: `no Driftbot present on ${window.location.pathname}`,
    });

    const { mouseFlowPush } = useTracking();

    mouseFlowPush(['setVariable', 'driftbot-error', 'no-driftbot-present', 'session', false]);

    throw new Error('no driftbot present');
  }

  window.drift.api.openChat();
};

export const useDrift = () => {
  if (import.meta.server) {
    return {
      driftBotPlaybookIds,
      hasDrift: false,
      showDriftBotOrThrow,
      openDrift,
    };
  }

  const hasDrift = computed(() => window.drift !== undefined);
  return {
    driftBotPlaybookIds,
    hasDrift,
    showDriftBotOrThrow,
    openDrift,
  };
};
